import assistantBlue from "./assets/assistant-blue.png";
import assistantBlueStar from "./assets/assistant-star-blue.png";

import type { FC } from "react";

import * as styles from "./bokioAssistantIcon.scss";

interface BokioAssistantIconProps {
	isLoading?: boolean;
}

export const BokioAssistantIcon: FC<BokioAssistantIconProps> = ({ isLoading = false }) => {
	return <img className={isLoading ? styles.loading : undefined} src={isLoading ? assistantBlueStar : assistantBlue} />;
};
